import { ApiService } from '../services/api_service';
import { Benutzerverwaltung } from './Benutzerverwaltung';
import * as config from '../wips.config.js';
import { ContextService } from '../services/context_service';
import { EditBerater } from './EditBerater';
import { EditUser } from './EditUser';
import { FormAddNewTool } from './FormAddNewTool';
import { IDs } from '../helpers/IDs';
import { KMUExterneFreigabe } from './KMUExterneFreigabe';
import { lazyInject } from '../services/inversify';
import * as React from 'react';
import { StartWillkommen } from '../bereiche/start/StartWillkommen';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

interface EditOptionTabsProps extends React.ClassAttributes<any> {
    containerId?: string;
    data: any;
    initialTab: number;
    onClose(): void;
    onRoutingChange: (routing: any) => void;
}

interface EditOptionTabsState {
    tabIndex: number;
}

export class EditOptionTabs extends React.Component<EditOptionTabsProps, EditOptionTabsState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: this.props.initialTab
        };
        this.isAdmin = this.apiService.isAdmin() || this.apiService.getUsername() === 'yang.wang@wips-home.de';
        this.isBerater = this.apiService.isBerater();
        this.isMainUser = this.apiService.isMainUser();
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;

    private devFeaturesMap: any = config.devFeaturesMap;
    private isAdmin: boolean;
    private isBerater: boolean;
    private isMainUser: boolean;

    render(): JSX.Element {
        const bereichKey = this.apiService.getBereichKey();
        const registrierung = (this.props.data || {})[IDs.ENT_REGISTRIERUNG] || [];
        const hasUUID: boolean = registrierung[0] && registrierung[0].uuid;
        const hasKonfiguration: boolean = !!((this.props.data || {})[IDs.ENT_KONFIGURATION] || []).length;
        const disabledBerater: boolean = !hasKonfiguration || bereichKey === 'privat';
        const disabledOptionen: boolean = !hasKonfiguration || !(this.isAdmin || this.isBerater || this.isMainUser);
        const disabledBV: boolean = !hasKonfiguration || !(this.isAdmin || this.isBerater || this.isMainUser);
        const disabledNT: boolean = disabledBV || bereichKey !== 'kommunalverwaltung';
        const disabledEF: boolean = !hasKonfiguration || !hasUUID || bereichKey !== 'handwerk';
        const styleTabPanel: React.CSSProperties = { display: 'flex', flexDirection: 'column', minHeight: 0, overflowY: 'auto' };

        return (
            <div
                style={{
                    width: 750, height: 650, backgroundColor: '#fff', borderBottomLeftRadius: 20,
                    borderBottomRightRadius: 20, display: 'flex', flexDirection: 'column', minHeight: 0
                }}
            >
                <Tabs
                    className='tabs-einstellungen'
                    style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
                    selectedIndex={this.state.tabIndex}
                    onSelect={
                        (tabIndex, lastIndex, event) => this.setState(
                            { tabIndex },
                            () => this.contextService.set('tabIdxUnternehmen', this.state.tabIndex)
                        )
                    }
                >
                    <TabList>
                        <Tab disabled={disabledOptionen}>Optionen</Tab>
                        <Tab>Anmeldung / Passwort</Tab>
                        <Tab disabled={disabledBerater}>Berater:Innen / Expert:Innen</Tab>
                        <Tab disabled={disabledBV}>Benutzerverwaltung</Tab>
                        <Tab disabled={disabledNT}>Neues Tool anlegen</Tab>
                        <Tab disabled={disabledEF}>Externe Freigaben</Tab>
                    </TabList>
                    <TabPanel style={styleTabPanel}>
                        {!disabledOptionen &&
                            <StartWillkommen
                                data={this.props.data}
                                onRoutingChange={this.props.onRoutingChange}
                                hideInfo={true}
                            />
                        }
                    </TabPanel>
                    <TabPanel style={styleTabPanel}>
                        <EditUser
                            containerId={this.props.containerId}
                            data={this.props.data}
                            onClose={this.props.onClose}
                        />
                    </TabPanel>
                    <TabPanel style={styleTabPanel}>
                        {this.isMainUser || this.isAdmin ?
                            <EditBerater
                                containerId={this.props.containerId}
                                data={this.props.data}
                                onClose={this.props.onClose}
                            />
                            : <div style={{ padding: 20, fontSize: 13 }}>
                                <i>
                                    Standard-Nutzer können Ihren Datensatz zur Einsicht für Berater freischalten und den
                                    gewünschten Berater in diesem Dialogfenster auswählen.<br />
                                    Diese Funktionalität ist für Sie nicht relevant und wird Ihnen daher nicht angezeigt.
                                </i>
                            </div>
                        }
                    </TabPanel>
                    <TabPanel style={styleTabPanel}>
                        {!disabledBV &&
                            <Benutzerverwaltung
                                containerId={this.props.containerId}
                                data={this.props.data}
                            />
                        }
                    </TabPanel>
                    <TabPanel style={styleTabPanel}>
                        {!disabledNT &&
                            <div style={{ overflowX: 'hidden' }}>
                                <div style={{ width: 550 }}>
                                    <FormAddNewTool
                                        containerId={this.props.containerId}
                                        data={this.props.data}
                                    />
                                </div>
                            </div>
                        }
                    </TabPanel>
                    <TabPanel style={styleTabPanel}>
                        {!disabledEF &&
                            <KMUExterneFreigabe
                                containerId={this.props.containerId}
                                data={this.props.data}
                            />
                        }
                    </TabPanel>
                </Tabs>
            </div>
        );
    }
}
